.hook-form-field {
  border: 1px solid var(--sbb-color-smoke);
  border-radius: var(--sbb-border-radius-4x);
  margin-top: 1rem;
  padding: 0.5rem;
  display: flex;
  flex-direction: column;

  &.has-focus {
    border-color: black;
  }
}

.panel-container {
  gap: 1rem;

  .hook-form-field {
    margin: 0;
    padding-top: 2px;
  }

  sbb-form-field,
  sbb-form-field:not(:first-of-type) {
    margin: 0;
    padding-top: 2px;
  }
}
